import React from 'react';
import classnames from 'classnames';
import { Trans } from 'react-i18next';
import Timestamp from '../../../Timestamp';
import s from './PublishedTime.scss';
const PublishedTime = ({ publishedTime, withoutText, isStash, className })=>{
    if (!publishedTime) {
        return null;
    }
    const timestamp = /*#__PURE__*/ React.createElement(Timestamp, {
        timestamp: publishedTime,
        showTooltip: true,
        showFullLengthOnMobile: true
    });
    if (isStash) {
        return /*#__PURE__*/ React.createElement("span", {
            className: classnames(s['root'], className)
        }, /*#__PURE__*/ React.createElement(Trans, {
            i18nKey: 'deviation.details.uploadedTime'
        }, "Uploaded: ", timestamp));
    }
    return /*#__PURE__*/ React.createElement("span", {
        className: classnames(s['root'], className)
    }, withoutText ? timestamp : /*#__PURE__*/ React.createElement(Trans, {
        i18nKey: 'deviation.details.publishedTime'
    }, "Published: ", timestamp));
};
PublishedTime.displayName = 'PublishedTime';
export default PublishedTime;
